import { cloneDeep } from "lodash";
import Cookies from "js-cookie";

// import { receiveServerErrors } from '../errors/error_actions';

const RECEIVE_LAST_SEEN_CHANNELS = "RECEIVE_LAST_SEEN_CHANNELS";
const RECEIVE_LAST_SEEN_CHANNEL = "RECEIVE_LAST_SEEN_CHANNEL";

const receiveChannels = (channels) => ({
  type: RECEIVE_LAST_SEEN_CHANNELS,
  channels,
});

const receiveChannel = (channel) => ({
  type: RECEIVE_LAST_SEEN_CHANNEL,
  channel,
});

export const fetchChannels = () => (dispatch) =>
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/channels`,
    data: {
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(channels) {
      dispatch(receiveChannels(channels));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });

export const updateChannel = (id, data) => (dispatch) => {
  $.ajax({
    method: "put",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/channels/${id}`,
    data,
    success(channel) {
      dispatch(receiveChannel(channel));
    },
    error(xhr) {
      // dispatch(receiveServerErrors(xhr));
    },
  });
};

export const lastSeenChannels = (state = [], payload = {}) => {
  const { type, channels, channel } = payload;
  const newState = cloneDeep(state);
  switch (type) {
    case RECEIVE_LAST_SEEN_CHANNELS:
      return channels;
    case RECEIVE_LAST_SEEN_CHANNEL:
      const i = state.findIndex((c) => c.pubnub_id === channel.pubnub_id);
      if (i === -1) {
        newState.push(channel);
      } else {
        newState[i] = channel;
      }
      return newState;
    default:
      return state;
  }
};
